import React from 'react';

interface ConfirmSquareIconProps {
  size?: number;
  color?: string;
}

const ConfirmSquareIcon: React.FC<ConfirmSquareIconProps> = function (props) {
  const { size = 40, color = '#66D392' } = props;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width={size - 1} height={size - 1} rx={size * 0.0875} fill="white" stroke={color} />
      <path d={`M${size * 0.325} ${size * 0.525} L${size * 0.41} ${size * 0.585} L${size * 0.775} ${size * 0.31}`} stroke="black" strokeLinecap="round" />
    </svg>
  );
};

ConfirmSquareIcon.defaultProps = {
  size: 40,
  color: '#66D392',
};

export default ConfirmSquareIcon;
